module.exports = __webpack_public_path__ + "img/login_bsgs_2.96c9a55c.svg";